import { InjectionToken } from '@angular/core';
import { RadioGroup } from './types';

export const RadioGroupToken = new InjectionToken<Maybe<RadioGroup>>('RadioGroup');
